<template>
  <div class="config-top">
    <div class="main-container">
      <div aria-label="Breadcrumb" class="breadcrumb-container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <span aria-current="page">設定トップ</span>
          </li>
        </ol>
      </div>
      <div class="container">
        <h2 class="config-headline">
          <img
            src="../assets/images/icon/icon_config_orange.svg"
            alt=""
            class="icon-config-headline"
          />
          設定トップ
        </h2>
        <div class="config-content">
          <ul class="config-screen-links">
            <li>
              <button class="button-config-top" @click="toDroneInfoPage">
                <span>
                  <img src="../assets/images/icon/icon_drone.svg" alt="" />
                </span>
                機体情報設定
              </button>
            </li>
            <li>
              <button class="button-config-top" @click="toFlightAreasPage">
                <span>
                  <img src="../assets/images/icon/icon_location_marker_black.svg" alt="" />
                </span>
                飛行エリア設定
              </button>
            </li>
            <li>
              <button class="button-config-top" @click="toFlightRoutesPage">
                <span>
                  <img src="../assets/images/icon/icon_route_black.svg" alt="" />
                </span>
                航路情報設定
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
const router = useRouter()
//機体情報設定画面へ遷移
const toDroneInfoPage = () => {
  router.push('/drone-info')
}

//飛行エリア設定画面へ遷移
const toFlightAreasPage = () => {
  router.push('/flight-areas')
}

//航路情報設定画面へ遷移
const toFlightRoutesPage = () => {
  router.push('/flight-routes')
}
</script>
